export default {
  id: "exam-cheer-2026",
  pride: 23552,
  slug: "exam-cheer-2026",
  series: "gaokao",
  category: ["video", "blog"],
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "【大考加油】来自超常发挥学长和他的图帕们的考前陪伴",
    en: "[Exam Cheer] Pre-Exam Companionship from an Overachieving Senior and His Tupas"
  },
  bilibiliVideoId: "BV1yDEJ6yEDf",
  descriptionKey: {
    zh: "来自超常发挥学长和他的图帕们的一段考前陪伴。除了高考，什么大考和困难都适用。",
    en: "Pre-exam companionship from an overachieving senior and his Tupas. Works for any major exam or challenge, not just Gaokao."
  },
  date: { year: 2026, month: 6, day: 6 },
  genres: ["陪伴", "励志"],
  themes: ["考前", "图帕", "方法论", "哲学"],
  developerNotesKey: {
    zh: "来自超常发挥学长和他的图帕们的一段考前陪伴。除了高考，什么大考和困难都适用哦！有许多实用的哲学和方法论，提供给你啦！工期太短导致经费不足+没统一声线+硬剪辑+没好好调整BGM，致歉。按出场顺序：银（高考逆袭）、缪斯（理想主义）、萝北（拓展探索）、公理（现实主义）、柿子（情感修复）、于启（具身探索）、金（超长期规划）、呼唤（作息修复）。",
    en: "Pre-exam companionship from an overachieving senior and his Tupas. Works for any big exam or challenge! Packed with practical philosophy and methodology. Apologies for the rough production — timeline was too short for consistent voicing, clean cuts, or proper BGM. In order of appearance: Yin (Gaokao overachiever), Muse (idealism), Luobei (exploration), Axiom (realism), Kaki (emotional repair), Yuqi (embodiment), Jin (long-term planning), Huhuan (sleep repair)."
  },
  tags: ["高考"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1yDEJ6yEDf/", textKey: { zh: "B站观看", en: "Watch on Bilibili" } }
  ]
};
